import FirstTimeChangePassword from './FirstTimeChangePassword';

export default FirstTimeChangePassword;
